export enum VoucherOperationType {
    INWARD = 'CL_INWARD_TRANSFER',
    OUTWARD = 'CL_OUTWARD_TRANSFER',
    ALL = '',
}

export enum VOUCHER_STATUS {
    CANCELED = 'CANCELED',
    EXPIRED = 'EXPIRED',
    NEW = 'NEW',
    REDEEMED = 'REDEEMED',
}

export interface IVoucherInquiryRequest {
    voucher_code: string;
    operation_code: VoucherOperationType;
}

export interface IVoucherInquiryResponse {
    voucher_code: string;
    issued_on: string;
    expiry_time: string;
    voucher_status: VOUCHER_STATUS;
    amount: number;
}

export interface IVoucherListRequest {
    operation_code?: VoucherOperationType;
    agent_username?: string;
    agent_id?: string;
    status?: string;
    voucher_code?: string;
    limit: number;
    after: string;
}

export interface IVoucherListIndex {
    voucher_code: string;
    issued_on: string;
    expiry_time: string;
    voucher_status: VOUCHER_STATUS;
    amount: number;
    currency: string;
    operation_code: VoucherOperationType;
    user: {
        id: string;
        first_name: string;
        last_name: string;
        email: string;
    };
}

export interface IVoucherListIndexAugmented extends IVoucherListIndex {
    _name?: string;
}

export interface IVoucherListResponse {
    has_more: boolean;
    next_page?: string;
    data: IVoucherListIndex[];
}

export interface IVoucherGenerationRequest {
    currency: string;
    amount: number;
    account_id: string;
    note: string;
    operation_code: VoucherOperationType;
    agent_id?: string;
    agent_username?: string;
    agent_account_id?: string;
}
export interface IVoucherGenerationResponse {
    voucher_code: string;
    duration: number;
    issued_on: string;
    expiry_time: string;
}

export enum RedemptionChannel {
    FIB = 'FIBPGW',
}
export interface IVoucherRedemptionRequest {
    channel: RedemptionChannel;
    external_ref_number?: string;
    operation_code: VoucherOperationType;
    agent_account_id: string;
    amount: number;
}

export interface IVoucherRedemptionResponse {
    currency: string;
    amount: number;
    fee_amount: number;
    account_id: string;
    status: string;
    transaction_id: string;
}
